import '@mdi/font/css/materialdesignicons.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import { colors } from '@/config/colors'

import Vue from 'vue'
import Vuetify from 'vuetify'

Vue.use(Vuetify, {
  options: {
    cspNonce: 'bd5af2d76fe645c3d5d65f52a60f7a52',
  },
})

/* Use named theme colors in scss files via var(--v-<color name from theme>-base) */
const opts = {
  theme: {
    options: {
      customProperties: true,
      cspNonce: 'bd5af2d76fe645c3d5d65f52a60f7a52',
    },
    themes: {
      light: {
        'primary': colors['primary-turquoise'],
        'primary-variant': colors['primary-turquoise'],
        'secondary': colors['pacific-blue'],
        'secondary-variant': colors['silver'],
        'accent': colors['pacific-blue'],

        'main': colors['gray'],
        'main-darken-1': colors['dove-gray'],
        'main-darken-2': colors['secondary-petrol'],
        'main-darken-3': colors['tundora'],
        'main-darken-4': colors['cod-gray'],
        'main-darken-5': colors['black'],
        'main-lighten-1': colors['secondary-petrol-light'],
        'main-lighten-2': colors['silver'],
        'main-lighten-3': colors['tertiary-sand'],
        'main-lighten-4': colors['tertiary-light-sand'],
        'main-lighten-5': colors['white'],

        'error': colors['red'],
        'gallery': colors['pacific-blue'],
        'info': colors['dodger-blue'],
        'success': colors['parsley'],
        'warning': colors['amber'],
        'search-input-bg': colors['mercury'],
        'search-bar-bg': colors['black'],
      },
    },
  },
  icons: {
    iconfont: 'md',
  },
}

export default new Vuetify(opts)
